import { InitOverrideFunction } from '@genial/services/dist/runtime';

export const messageError = '―';

const confirmOrderWarningProps = {
  title: 'Atenção',
  icon: 'Warning',
  iconColor: 'feedback.attention.default',
  confirmText: 'Confirmar',
  confirmColor: 'brand.tertiary.principal',
} as const;

export const confirmOrderData = {
  ...confirmOrderWarningProps,
  description:
    'Ao confirmar você estará de acordo com os termos de adesão e conhecendo os riscos associados aos produtos.',
} as const;

export const getRefusalOrderData = (isRescue: boolean) =>
  ({
    title: `Você confirma a recusa da ordem de ${isRescue ? 'resgate' : 'investimento'}?`,
    confirmText: 'Confirmar',
    confirmColor: 'brand.tertiary.principal',
    description:
      'Após a recusa, a ordem será encerrada. Fale com seu assessor para novas opções adequadas ao seu perfil.',
  } as const);

export const addAuthorizationHeader = (jwtToken?: string): InitOverrideFunction => {
  return async ({ init }) => {
    const headers = new Headers(init.headers);
    headers.append('Authorization', `Bearer ${jwtToken}`);

    return {
      ...init,
      headers,
    };
  };
};

export const removeAuthorizationHeader = (): InitOverrideFunction => {
  return async ({ init }) => {
    const headers = new Headers(init.headers);
    headers.delete('Authorization');

    return {
      ...init,
      headers,
    };
  };
};
